import React from 'react';
import DrawingResult from "../DrawingResult";
import DrawingResultCircle from "../../lotto12v3/DrawingResult";
import BettingDialog from "../../lotto5/BettingDialog";
import {lotto12DrawStyle} from "../../../constants/general";
import {useLotto12v2} from "../../../store/lotto12v2/Lotto12v2Context";
import BettingBoardMobile from "./BettingBoardMobile";
import TabView from "../../lotto/TabView";
import ResultHistory from "../ResultHistory";
import RecentBetting from "../RecentBetting";

const BettingWrapper = (props) => {
    const lotto = useLotto12v2()
    return <Betting {...lotto} {...props}/>
}

class Betting extends React.Component {

    render() {
        const {
            t,
            drawStyle,
            afterPrint,
            changeBetAmount,
            clickAmountBetBtn,
            onConfirmBetting,
            resetDefaultAmount,
            onCancelBetting,
            onBetting,
            appClass
        } = this.props;

        const tabs = [
            t("labels:drawing.betting"),
            t("labels:drawing.result")
        ];
        const children = [
            <RecentBetting afterPrint={afterPrint} {...this.props}/>,
            <ResultHistory isMobile/>
        ]

        return (
            <div className="">
                <div>
                    {drawStyle === lotto12DrawStyle.square && <DrawingResult isMobile/>}
                    {drawStyle === lotto12DrawStyle.circle && <DrawingResultCircle isMobile/>}
                    <BettingBoardMobile onBetting={onBetting}/>

                    <div className="tab-view border-all">
                        <TabView children={children} tabs={tabs}/>
                    </div>
                </div>
                <BettingDialog changeBetAmount={changeBetAmount}
                               clickAmountBetBtn={clickAmountBetBtn}
                               onConfirmBettingLotto5={onConfirmBetting}
                               resetDefaultAmount={resetDefaultAmount}
                               onCancelBetting={onCancelBetting}
                               classDialog="bet-mix-dialog"
                               appClass={appClass}
                               {...this.props}/>
            </div>
        );
    };
}

export default BettingWrapper;

